import { amplitudeEventsLib } from '../amplitude-events';
import type { MainPageVariant } from '../amplitude-events';

export const lastSearchesShow = (variant?: MainPageVariant) => {
  amplitudeEventsLib.lastSearchesShow(variant);
};

export const lastSearchesClick = (
  number: number,
  variant?: MainPageVariant,
) => {
  amplitudeEventsLib.lastSearchesClick(number, variant);
};

export const lastSearchesRemove = (
  number: number,
  variant?: MainPageVariant,
) => {
  amplitudeEventsLib.lastSearchesRemove(number, variant);
};
